module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/resources-virtual"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Add / Update Resource")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Resource Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.full_name),
      expression: "gRowObj.full_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.full_name.required
    },
    attrs: {
      "type": "text",
      "id": "full_name",
      "placeholder": "Resource Name"
    },
    domProps: {
      "value": (_vm.gRowObj.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "full_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.full_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter resource name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.client_id.required
    },
    attrs: {
      "id": "client_id"
    },
    model: {
      value: (_vm.gRowObj.client_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "client_id", $$v)
      },
      expression: "gRowObj.client_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an Customer--")]), _vm._v(" "), _vm._l((_vm.clientList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "value": data.id,
        "selected": data.id === _vm.gRowObj.client_id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.client_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an client.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country_id.required
    },
    attrs: {
      "id": "country_id"
    },
    on: {
      "change": function($event) {
        _vm.getLanguageList();
        _vm.getMunicipalityList();
      }
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data) {
    return _c('option', {
      key: data.country_id,
      domProps: {
        "selected": data.country_id === _vm.gRowObj.country_id,
        "value": data.country_id
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Service Area")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "Add Keywords",
      "multiple": true,
      "options": _vm.municipalityList,
      "search-nested": ""
    },
    model: {
      value: (_vm.gRowObj.selectedMunicipalities),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "selectedMunicipalities", $$v)
      },
      expression: "gRowObj.selectedMunicipalities"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.resource_type_id.required
    },
    attrs: {
      "id": "resource_type_id"
    },
    model: {
      value: (_vm.gRowObj.resource_type_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "resource_type_id", $$v)
      },
      expression: "gRowObj.resource_type_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an Type--")]), _vm._v(" "), _vm._l((_vm.resourcesTypeList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "value": data.id,
        "selected": data.id === _vm.gRowObj.resource_type_id
      }
    }, [_vm._v(_vm._s(data.type_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.resource_type_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an type.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "drillDownApp"
    }
  }, [_vm._v("Drill Down App")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose Drill Down App--",
      "multiple": false,
      "options": _vm.drillDownApps,
      "search-nested": ""
    },
    model: {
      value: (_vm.gRowObj.selectedDrillDownApp),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "selectedDrillDownApp", $$v)
      },
      expression: "gRowObj.selectedDrillDownApp"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Base URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.base_uri),
      expression: "gRowObj.base_uri"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.base_uri.url
    },
    attrs: {
      "type": "text",
      "id": "base_uri",
      "placeholder": "Base URL"
    },
    domProps: {
      "value": (_vm.gRowObj.base_uri)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "base_uri", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.base_uri.url) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter valid base url.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.referral_source.required
    },
    attrs: {
      "placeholder": "--Choose or Enter source--",
      "multiple": false,
      "defaultOptions": true,
      "load-options": _vm.loadOptions,
      "async": true,
      "id": "referral_source",
      "search-nested": "",
      "cacheOptions": false
    },
    on: {
      "select": _vm.addNewSource
    },
    scopedSlots: _vm._u([{
      key: "value-label",
      fn: function(ref) {
        var node = ref.node;

        return _c('div', {}, [_vm._v(_vm._s(node.raw.customLabel))])
      }
    }]),
    model: {
      value: (_vm.gRowObj.referral_source),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "referral_source", $$v)
      },
      expression: "gRowObj.referral_source"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.referral_source.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose or enter resource source.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [(_vm.isEdit) ? _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [(_vm.isGoogleSheetsAvailable) ? _c('div', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("DDE Google Sheets")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.isCustomerSpecificAvailable) ? _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('a', {
    attrs: {
      "href": ("" + (_vm.googleSheetLinks.customerSpecific)),
      "target": "_blank"
    }
  }, [_vm._v("Customer Specific Google Sheet")])]) : _vm._e(), _vm._v(" "), (_vm.isFacilitySpecificAvailable) ? _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('a', {
    attrs: {
      "href": ("" + (_vm.googleSheetLinks.facilitySpecific)),
      "target": "_blank"
    }
  }, [_vm._v("Facility Specific Google Sheet")])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline padding-botton-15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelectedServices),
      expression: "allSelectedServices"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelectedServices) ? _vm._i(_vm.allSelectedServices, null) > -1 : (_vm.allSelectedServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelectedServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelectedServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelectedServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelectedServices = $$c
        }
      }, function($event) {
        return _vm.selectAllServices('service')
      }]
    }
  }), _vm._v(" Select All")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service) {
    return _c('div', {
      key: service.id
    }, [_c('div', {
      staticClass: "checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.services),
        expression: "gRowObj.services"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": service.id,
        "checked": Array.isArray(_vm.gRowObj.services) ? _vm._i(_vm.gRowObj.services, service.id) > -1 : (_vm.gRowObj.services)
      },
      on: {
        "click": function($event) {
          return _vm.selectService('service')
        },
        "change": function($event) {
          var $$a = _vm.gRowObj.services,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = service.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "services", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "services", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "services", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(service.legacy_name) + "\n                              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline padding-botton-15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelectedProducts),
      expression: "allSelectedProducts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelectedProducts) ? _vm._i(_vm.allSelectedProducts, null) > -1 : (_vm.allSelectedProducts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelectedProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelectedProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelectedProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelectedProducts = $$c
        }
      }, function($event) {
        return _vm.selectAllServices('product')
      }]
    }
  }), _vm._v(" Select All")]), _vm._v(" "), _vm._l((_vm.productList), function(data) {
    return _c('div', {
      key: data.id
    }, [_c('div', {
      staticClass: "checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.products),
        expression: "gRowObj.products"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.id,
        "checked": Array.isArray(_vm.gRowObj.products) ? _vm._i(_vm.gRowObj.products, data.id) > -1 : (_vm.gRowObj.products)
      },
      on: {
        "click": function($event) {
          return _vm.selectService('product')
        },
        "change": function($event) {
          var $$a = _vm.gRowObj.products,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "products", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "products", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "products", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(data.legacy_name) + "\n                              ")])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submittedRes && !_vm.$v.resourcesTextObj.language_id.required
    },
    attrs: {
      "id": "language_id"
    },
    model: {
      value: (_vm.resourcesTextObj.language_id),
      callback: function($$v) {
        _vm.$set(_vm.resourcesTextObj, "language_id", $$v)
      },
      expression: "resourcesTextObj.language_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Language--")]), _vm._v(" "), _vm._l((_vm.languageList), function(data) {
    return _c('option', {
      key: data.language_id,
      domProps: {
        "selected": data.language_id === _vm.resourcesTextObj.language_id,
        "value": data.language_id
      }
    }, [_vm._v(_vm._s(data.language_name))])
  })], 2), _vm._v(" "), (_vm.submittedRes && !_vm.$v.resourcesTextObj.language_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an language.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('label', [_vm._v("Button Text")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.resourcesTextObj.button_text),
      callback: function($$v) {
        _vm.$set(_vm.resourcesTextObj, "button_text", $$v)
      },
      expression: "resourcesTextObj.button_text"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose Button Text--")]), _vm._v(" "), _vm._l((_vm.resourceButtonTexts), function(data) {
    return _c('option', {
      key: data.value,
      domProps: {
        "selected": data.value === _vm.resourcesTextObj.button_text,
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.label))])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-sm-8 col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-9 col-sm-9 col-md-9"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "resource-long-text"
    }
  }, [_vm._v("Resource Long Text")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resourcesTextObj.resource_display_text),
      expression: "resourcesTextObj.resource_display_text"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submittedRes && (!_vm.$v.resourcesTextObj.resource_display_text.required || !_vm.$v.resourcesTextObj.resource_display_text.maxLength)
    },
    attrs: {
      "rows": "4",
      "id": "langageMessage",
      "placeholder": "Resource Long Text"
    },
    domProps: {
      "value": (_vm.resourcesTextObj.resource_display_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resourcesTextObj, "resource_display_text", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submittedRes && !_vm.$v.resourcesTextObj.resource_display_text.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter a text.")]) : _vm._e(), _vm._v(" "), (_vm.submittedRes && !_vm.$v.resourcesTextObj.resource_display_text.maxLength) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Text is exceeding character limit of 1000 characters.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-3 col-sm-3 col-md-3 padding-top-15px"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle add-property",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.addResourcesText()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-9 col-sm-9 col-md-9"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Resource Short Text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resourcesTextObj.resource_short_text),
      expression: "resourcesTextObj.resource_short_text"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submittedRes && (!_vm.$v.resourcesTextObj.resource_short_text.required || !_vm.$v.resourcesTextObj.resource_short_text.maxLength)
    },
    attrs: {
      "type": "text",
      "id": "shortText",
      "placeholder": "Resource Short Text"
    },
    domProps: {
      "value": (_vm.resourcesTextObj.resource_short_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resourcesTextObj, "resource_short_text", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submittedRes && !_vm.$v.resourcesTextObj.resource_short_text.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter resource short text.")]) : _vm._e(), _vm._v(" "), (_vm.submittedRes && !_vm.$v.resourcesTextObj.resource_short_text.maxLength) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Text is exceeding character limit of 250 characters.")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [(Object.keys(_vm.gRowObj.resourcesText).length) ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.gRowObj.resourcesText), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.language_name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm.getButtonText(item.button_text)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35%",
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(item.resource_display_text))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%",
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(item.resource_short_text))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.editResourcesText(item, index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteResourcesText(item, index)
        }
      }
    })])])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addOrUpdateOrDeleteResource(0)
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addOrUpdateOrDeleteResource(1)
      }
    }
  }, [_vm._v("Publish")])])])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Referral Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "required",
    attrs: {
      "for": "referral_source"
    }
  }, [_vm._v("Referral Source\n                          "), _c('span', {
    attrs: {
      "title": "Provide source for this referral for better resource management"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Products/Services available")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Display text for resource")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("Button Text")]), _vm._v(" "), _c('th', [_vm._v("Resource Long Text")]), _vm._v(" "), _c('th', [_vm._v("Resource Short Text")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-22fb6e90","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources-management/virtual/addOrUpdateResources.vue
// module id = ERfj
// module chunks = 1